import {Typography} from '@mui/material';
import Box from '@mui/material/Box';
import {bool} from 'prop-types';

import {SIDEBAR_CONTACT_BUTTON_SIZE} from '../../../const';
import useContact from '../../../hooks/providers/useContact';

const RequestNewModuleContactButton = ({isVisible = false}) => {
  const zIndex = isVisible ? 'inherit' : -1;
  const opacity = isVisible ? 1 : 0;

  const {setIsContactFormOpen} = useContact();

  return (
    <Box
      onClick={() => setIsContactFormOpen(true)}
      sx={{
        zIndex,
        opacity,
        width: SIDEBAR_CONTACT_BUTTON_SIZE,
        height: SIDEBAR_CONTACT_BUTTON_SIZE,
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        bottom: 0,
        margin: '0 8px',
        mb: 1,
        cursor: 'pointer',
        background: 'white',
        borderRadius: 3,
        border: '2px solid #DEDEDE'
      }}
    >
      <Typography textAlign="center" fontSize={9}>
        Besoin d'un nouvel outil ?
      </Typography>
    </Box>
  );
};

RequestNewModuleContactButton.propTypes = {
  isVisible: bool
};

export default RequestNewModuleContactButton;
